export const FEEDBACK_URLS = {
  employeeUrl: 'https://github.com/github/sub-issues/discussions/447',
  publicUrl: 'https://gh.io/sub-issues-feedback',
}
